import { rootStateBranchSelector } from 'shared/utils/rootStateBranchSelector';

export const filtersSelector = rootStateBranchSelector('filters');
